"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.getAll = void 0;
var voyageMissionData_1 = require("@voyage/missions/voyageMissionData");
var _navLocations = [];
function getAll() {
    return _navLocations;
}
exports.getAll = getAll;
function registerAll() {
    _navLocations = [
        {
            locationName: 'Starbase-7',
            isStarbase: true,
            missionType: voyageMissionData_1.EVoyageMissionType.Starbase,
        },
        {
            locationName: 'Starbase-12',
            isStarbase: true,
            missionType: voyageMissionData_1.EVoyageMissionType.Starbase,
        },
        {
            locationName: 'Enemy territory',
            isStarbase: false,
            missionType: voyageMissionData_1.EVoyageMissionType.CombatZone1,
        },
        {
            locationName: 'Mission: hammerhead',
            isStarbase: false,
            missionType: voyageMissionData_1.EVoyageMissionType.FightAlienShip2,
        },
        {
            locationName: 'Mission: aliens 1',
            isStarbase: false,
            missionType: voyageMissionData_1.EVoyageMissionType.FightAliens1,
        },
        {
            locationName: 'Mission: aliens 2',
            isStarbase: false,
            missionType: voyageMissionData_1.EVoyageMissionType.FightAliens2,
        },
        {
            locationName: 'Mission: aliens 3',
            isStarbase: false,
            missionType: voyageMissionData_1.EVoyageMissionType.FightAliens3,
        },
    ];
}
exports.registerAll = registerAll;
